module.exports = __webpack_public_path__ + "finisher.6bebaba03a4b44a3b0a2.svg";